import $ from "jquery";

$(() => {
  if (document.querySelector('.checkbox')) {
    const checkboxes = $(".checkbox");
    if (checkboxes.length) {
      checkboxes.each((i, checkbox) => {
        let checkmark = $("<span>").addClass("checkmark");
        let input = $(checkbox).find("input");
        checkmark.insertAfter(input);
      });
    };
  }
});